"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClearFiltersCallback = exports.isAnyFilterChecked = exports.getOptionsFromAdvancedFilters = exports.getCheckedFilterCount = void 0;
var getCheckedFilterCount = function (options) {
    if (!options) {
        return 0;
    }
    return options.reduce(function (totalCheckedOptions, option) { return totalCheckedOptions + (option.isChecked && !option.isLocked ? 1 : 0); }, 0);
};
exports.getCheckedFilterCount = getCheckedFilterCount;
var getOptionsFromAdvancedFilters = function (advancedFilters) {
    if (!advancedFilters) {
        return [];
    }
    return advancedFilters
        .reduce(function (options, advancedFilter) { return options.concat(advancedFilter.options); }, [])
        .filter(function (option) { return !option.isLocked; });
};
exports.getOptionsFromAdvancedFilters = getOptionsFromAdvancedFilters;
var isAnyFilterChecked = function (advancedFilters) {
    if (!advancedFilters) {
        return false;
    }
    return (0, exports.getCheckedFilterCount)((0, exports.getOptionsFromAdvancedFilters)(advancedFilters)) > 0;
};
exports.isAnyFilterChecked = isAnyFilterChecked;
var getClearFiltersCallback = function (filters, onRemoveFilter) {
    return function () {
        if (filters && filters.advanced) {
            // don't clear filters for which we don't render pills
            filters.advanced
                .filter(function (filter) { return !filter.isLocked; })
                .forEach(function (advancedFilter) {
                advancedFilter.options.forEach(function (option) {
                    if (option.isChecked && !option.isLocked) {
                        onRemoveFilter === null || onRemoveFilter === void 0 ? void 0 : onRemoveFilter(advancedFilter.name, option.value);
                    }
                });
            });
        }
    };
};
exports.getClearFiltersCallback = getClearFiltersCallback;
//# sourceMappingURL=AdvancedFilter.js.map